<template>
    <div id="container" style="    width: 100%; display: flex;position:relative" >

        <div style="    display: flex;justify-content: center;margin-top: 40px;width: 100%; " class="ai-logo">
          
            <div>
                <div style="width: 100%;text-align: center;" >
                    <img src="../../assets/ailogo.png" style="width: 90px;height: 90px;"> 
                    <div class="title-line">AI洞察知识库
                </div>
            </div>
            <div v-if="show">
                <div v-if="cardList.length>0">
                <div style="width: 100%;text-align: center;" >
             
                    <div >
                        <!-- <div class="titleOne" style="color: rgb(44 62 80);font-weight: normal;font-size: 18px;">所有的回答全部来自于公司已订阅情报！ -->
                            <div class="sub-title-line">所有的回答全部来自于公司已订阅情报！</div>
                       
                    <div class="sub-sub-title-line" >在这里，您可以获得让AI帮您快速检索、快速问答、简单统计、写报告的绝佳体验。
                    </div>

                </div>
                  
                </div>
                <div style="    display: flex;justify-content: center;text-align: center;margin-top:50px;flex-wrap: wrap;
                    row-gap: 50px;    align-items: stretch;">

                    <div v-for="item in cardList" class="cardList" @click="toClick(item)">
                        <div class="cardListText" style="">
                            <div class="cardListTextItem" style="font-weight: 700;">{{ item.appName }}</div>
                            <div  class="cardListTextItemDescription">{{ item.description }}</div>
                        </div>


                    </div>
                 
                </div>
                <div class="sub-sub-title-line" style="  text-align: center; font-weight: bolder;
    letter-spacing: 2px;    margin-top: 50px;">选择一个，快速体验</div>
            </div>
            <div v-else>
                <div  class="titleOne noDatabase" style="text-align: center;">
                 <div  class="sub-sub-title-line" style="font-size: 13px;">贵司尚未开通该服务</div>
                 <div class="sub-sub-title-line" style="font-size: 13px;">开通后，企业已有的情报类别将自动转为多个子知识库，在AI语言大模型的介入下，可为团队成员
                </div>
                <div class="sub-sub-title-line" style="font-size: 13px;">提供快速检索、快速问答、简单统计、写报告的绝佳体验。</div>
                <div class="sub-sub-title-line" style="font-size: 13px;">让沉淀的情报，真正地动起来 ！</div>
                <div class="sub-sub-title-line" style="font-size: 13px;">我们的产品可以有效控制大模型幻觉问题，所有的回答全部来自于公司已订阅情报。</div>
  
              
                     <!-- <img src="../../assets/video.png" style="width: 467px;height: 263px;"> -->
                     <div style="display: flex;justify-content: center;">
                     
                        <div :style="videoImg" class="dflex justifyCenter alignCenter cursorPointer videoClass" @click="toWacth">
                        
    <div class="badge">
                            <svg-icon name="播放" size="20" color="black" style="margin-right: 0px !important;"></svg-icon>
                        </div>
                        </div>
    <!-- <videoPlay 
    v-bind="options" 
    @play="onPlay"
    @pause="onPause" 
    @timeupdate="onTimeupdate" 
    @canplay="onCanplay" ></videoPlay> -->
                     </div>
                     <div  class="sub-sub-title-line" style="font-size: 13px;">查看视频，了解AI洞察知识库可以为您做些什么 </div>
                <div  class="sub-sub-title-line"  style="  font-weight: 600;font-size: 13px; ">联系我们，了解更多</div>
            </div>
            </div>
            </div>
           
        
            </div>
           

        </div>
      <!-- <div style="    position: relative;" ref="contentRef">
            <a-modal v-model:visible="videoVisible" :footer ="null"  :closable="false"  
    :getContainer="false"
 
    >
            <div style="    display: flex;justify-content: center;">
                <div style="    position: absolute;
    right: -20px;
    top: -20px;cursor: pointer;" @click="videoVisible=false"><close-outlined   style="color: white;font-size:20px"/></div>
                <videoPlay ref="videoPlayer"
    v-bind="options" 
    @play="onPlay"
    @pause="onPause" 
    @timeupdate="onTimeupdate" 
    @canplay="onCanplay" ></videoPlay>
            </div>
    </a-modal>
        </div>  -->
        <!-- <div v-if="videoVisible==true">
            <div class="modal-overlay-contain "></div>
            <div  class="modal-overlay">
    <div class="modal-container">
        <div style="    display: flex;justify-content: center;">
                <div style="    position: absolute;
    right: -20px;
    top: -20px;cursor: pointer;" @click="videoVisible=false"><close-outlined   style="color: white;font-size:20px"/></div>
                <videoPlay ref="videoPlayer"
    v-bind="options" 
    @play="onPlay"
    @pause="onPause" 
    @timeupdate="onTimeupdate" 
    @canplay="onCanplay" ></videoPlay>
            </div>
    </div>
  </div>
        </div> -->
        <video
        webkit-playsinline
     v-if="videoPlayerShow"
      ref="videoPlayer"
      class="hidden-video"
      src="https://enplus.oss-cn-guangzhou.aliyuncs.com/qbqq-ai-show-video.mp4"
      controls
    />
        <!-- <videoPlay ref="videoPlayer" v-if="videoPlayerShow"
    v-bind="options" 
    @play="onPlay"
    @pause="onPause" 
    @timeupdate="onTimeupdate" 
    @canplay="onCanplay" ></videoPlay> -->
        <a-modal
      v-model:visible="videoVisible"
      title="演示视频"
      @ok="handleOk"
      width="100%"
      wrapClassName="full-modal"

    >
    <videoPlay ref="videoPlayer" 
    v-bind="options" 
    @play="onPlay"
    @pause="onPause" 
    @timeupdate="onTimeupdate" 
    @canplay="onCanplay" ></videoPlay>
    </a-modal>
    </div>
  

</template>
<script setup>

import "vue3-video-play/dist/style.css";
import { videoPlay } from "vue3-video-play";
import  newImage from '@/assets/封面.jpg';
import  videoSrc from '@/assets/12月6日.mp4';
import { CloseOutlined } from '@ant-design/icons-vue';

import router from '@/router';
import { computed, nextTick, onMounted, onUnmounted, reactive, ref } from 'vue';
import { getApp } from "./js";
import store from "@/store";
const contentRef = ref(null);
const cardList = ref([
])
const index=ref(0)
const show = ref(false)
const srcUrl=ref(videoSrc)
const options = reactive({
//   width: '1120px', //播放器高度
  height: '100%', //播放器高度

  muted: false, //静音
  webFullScreen: false,
  speedRate: ["0.75", "1.0", "1.25", "1.5", "2.0"], //播放倍速
  autoPlay: false, //自动播放
  loop: false, //循环播放
  mirror: false, //镜像画面
  ligthOff: false,  //关灯模式
  volume: 0.3, //默认音量大小
  control: false, //是否显示控制器
  title: '', //视频名称
  src: srcUrl.value, //视频源

})
const videoPlayerShow=ref(false)
const onFullScreenChange=()=>{
    if (!document.fullscreenElement) {
        videoPlayerShow.value=false
    // 在这里添加退出全屏后的逻辑，比如隐藏视频元素或显示其他内容
  }
 
}
onMounted(() => {
    document.addEventListener('fullscreenchange', onFullScreenChange);
  document.addEventListener('webkitfullscreenchange', onFullScreenChange);
  document.addEventListener('mozfullscreenchange', onFullScreenChange);
  document.addEventListener('msfullscreenchange', onFullScreenChange);
    // document.getElementById('mainContent').classList.add('Qbg')
    if(document.getElementById('mainContent')){
      document.getElementById('mainContent').classList.add('overflow-y')
    }
    toGetApp()
 
})
const toGetApp=()=>{
    getApp({companyId:store.getters.company.companyId}).then((res)=>{
      if(res.data&&res.data.length>0){
        res.data=res.data.sort((a,b)=>b.updateTime-a.updateTime)
      }
       cardList.value=res.data
       show.value=true
    })
}
onUnmounted(() => {
    // document.getElementById('mainContent').classList.remove('Qbg')
    document.removeEventListener('fullscreenchange', onFullScreenChange);
  document.removeEventListener('webkitfullscreenchange', onFullScreenChange);
  document.removeEventListener('mozfullscreenchange', onFullScreenChange);
  document.removeEventListener('msfullscreenchange', onFullScreenChange);
 if( document.getElementById)('mainContent')
    document.getElementById('mainContent').classList.remove('overflow-y')

})
const toClick = (item) => {
    router.push({ path: "/KnowledgeDetail", query: { knowId: item.id } })

}

const imageUrl=ref(newImage)
const videoImg =computed(() =>({
    backgroundImage:'url('+imageUrl.value+')',
    backgroundSize: 'cover',
     backgroundPosition: 'center',
    width:'480px',
    height:'200px',
}
))
const videoVisible=ref(false)
const videoPlayer=ref(null)

const toWacth=()=>{
    videoPlayerShow.value=true

        nextTick(()=>{
            const videoElement = videoPlayer.value;
            console.log(videoPlayer.value,'videoElement')
            videoElement.play().then(() => {
    if (videoElement.requestFullscreen) {
      videoElement.requestFullscreen().catch(err => {
        console.error('Error attempting to enable full-screen mode:', err);
      });
    } else if (videoElement.mozRequestFullScreen) { // Firefox
      videoElement.mozRequestFullScreen().catch(err => {
        console.error('Error attempting to enable full-screen mode in Firefox:', err);
      });
    } else if (videoElement.webkitRequestFullscreen) { // Chrome, Safari and Opera
      videoElement.webkitRequestFullscreen().catch(err => {
        console.error('Error attempting to enable full-screen mode in WebKit:', err);
      });
    } else if (videoElement.msRequestFullscreen) { // IE/Edge
      videoElement.msRequestFullscreen().catch(err => {
        console.error('Error attempting to enable full-screen mode in IE/Edge:', err);
      });
    }
  }).catch(err => {
    console.error('Error attempting to play the video:', err);
  });



        })
 
}


    

//    nextTick(()=>{
//     videoPlayer.value.webFullScreen=true
//     console.log(videoPlayer.value,'xiix')
//     // videoPlayer.value.requestFullscreen()
//     //  videoPlayer.value.play()
//    })
    // videoVisible.value=true
    // nextTick(()=>{
    //     videoPlayer.value.play()
    // })


const getContainer = () => {

  return contentRef.value
}
</script>
<style scoped>

.hidden-video {
  /* 这个类实际上在全屏时不会用到，因为视频会覆盖整个屏幕 */
  /* 但为了保持代码的清晰性，我们还是保留了这个类 */
  /* 你可以根据需要添加其他样式来控制视频的默认显示状态 */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  
  /* 初始状态下隐藏，但实际上在全屏时这个属性会被覆盖 */

}
@media (min-width: 1600px) {
    .ai-logo{
        margin-top: 160px !important;
    }
}
.videoClass{
    margin: 20px 0px;
}
.dflex{
    display: flex;
}
.justifyCenter{
    justify-content: center;
}
.alignCenter{
    align-items: center;
}
.cursorPointer{
    cursor: pointer;
}
.badge{
    padding: 6px;
    background: rgba(0, 0, 0, .64);
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-backdrop-filter: blur(3px);
    backdrop-filter: blur(3px);
    border-radius: 50px;
    transition: padding-left .6s cubic-bezier(.175,.885,.32,2), padding-right .6s cubic-bezier(.175,.885,.32,2), min-width .6s cubic-bezier(.175,.885,.32,2);
    width: 25px;
    height: 25px;
}
.titleOne{
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 2px;
    color: #8f8f8f;    line-height: 40px;
}
@media screen  and (max-width:1600px){
    .titleOne.noDatabase{
        font-size:16px !important;
        line-height: 32px !important;
    }
   
}



.cardList {
    width: 200px;



    margin: 0 10px;
    cursor: pointer;
    background: linear-gradient(119.3deg, hsla(0, 0%, 100%, .2), hsla(0, 0%, 100%, .02));
    /* box-shadow: 3px 3px 20px rgb(19 180 188 / 22%); */
    box-shadow: 0px 2px 11px rgb(103 104 104 / 22%) ;
    border-radius: 10px;

}

.cardList:hover {
    /* box-shadow: 3px 3px 20px rgb(85 216 223 / 42%); */
    box-shadow: 0px 2px 11px rgb(103 104 104 / 22%) ;
    scale: 1.1
}

.cardListText {
    padding: 20px;
 
    font-family: PingFang SC;
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 34px;
    /* color: #13b4bc; */
    color:#1A2029;
    text-shadow: 0 1px 2px rgba(0, 0, 0, .1);
}
.cardListTextItemDescription{
    font-size: 14px;
    line-height: 28px;
}
</style>
<style>
.overflow-y{
  overflow-y: auto;
}
.modal-overlay-contain {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 100%;
  position: relative;
}



.custom-modal {
  position: absolute;
  top: 50% !important;
  left: 50%!important;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 600px; /* 根据需要调整宽度 */
}
</style>

<style lang="scss">
// #refPlayerWrap{
//     position: absolute;
//     width: auto;
//     background-color: white;
// }
.full-modal {
  .ant-modal {
    max-width: 100%;
    top: 0;
    padding-bottom: 0;
    margin: 0;
  }
  .ant-modal-content {
    display: flex;
    flex-direction: column;
    height: calc(100vh);
  }
  .ant-modal-body {
    flex: 1;
    position: relative;
    padding: 0px;
    display: flex;
    justify-content: center;
  }
}
</style>